webpackJsonp([64936714608522],{

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photogram = function (_React$Component) {
	  _inherits(Photogram, _React$Component);
	
	  function Photogram(props) {
	    _classCallCheck(this, Photogram);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Photogram.prototype.render = function render() {
	    var sketchfab_id = this.props.sketchfab_id;
	    return _react2.default.createElement(
	      'div',
	      { className: 'sketchfab-embed-wrapper' },
	      _react2.default.createElement('iframe', { width: '100%', height: '480', src: "https://sketchfab.com/models/" + sketchfab_id + "/embed", frameborder: '0', allow: 'autoplay; fullscreen; vr', mozallowfullscreen: 'true', webkitallowfullscreen: 'true' })
	    );
	  };
	
	  return Photogram;
	}(_react2.default.Component);
	
	exports.default = Photogram;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.photogramQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(10);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _rehypeReact = __webpack_require__(33);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _ObjectData = __webpack_require__(34);
	
	var _ObjectData2 = _interopRequireDefault(_ObjectData);
	
	var _Photogram = __webpack_require__(227);
	
	var _Photogram2 = _interopRequireDefault(_Photogram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotogramTemplate = function (_React$Component) {
	  _inherits(PhotogramTemplate, _React$Component);
	
	  function PhotogramTemplate() {
	    _classCallCheck(this, PhotogramTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PhotogramTemplate.prototype.render = function render() {
	    var resource = this.props.data.markdownRemark;
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    var renderAst = new _rehypeReact2.default({
	      createElement: _react2.default.createElement,
	      components: { 'object-block': _ObjectData2.default }
	    }).Compiler;
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          resource.frontmatter.title + ' | ' + siteTitle
	        ),
	        _react2.default.createElement('html', { lang: 'en' })
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        resource.frontmatter.title
	      ),
	      _react2.default.createElement(_Photogram2.default, { sketchfab_id: resource.frontmatter.sketchfab }),
	      renderAst(resource.htmlAst)
	    );
	  };
	
	  return PhotogramTemplate;
	}(_react2.default.Component);
	
	exports.default = PhotogramTemplate;
	var photogramQuery = exports.photogramQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-photogram-js-855796850c5db002cdb6.js